/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
if (!customElements.get('blog-slider-component')) {
  class BlogSliderComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.splide');
      this.sliderList = this.slider.querySelector('.splide__list');
      this.options = JSON.parse(this.slider.dataset.options);
      
      this.Splide = new theme.Splide(this.slider, this.options);

      this.Splide.on('moved', () => this.resizeHeight() );
      this.Splide.on('mounted', () => this.onResize() );

      this.Splide.mount();
    }

    onResize() {
      this.slideshowResizeObserver = new ResizeObserver((entries) => {
        const activeSlide = this.slider.querySelector(
          '.splide__slide.is-active'
        );
        const activeContent = activeSlide.querySelector(
          '.slide__contain'
        );
      });

      this.slideshowResizeObserver.observe(this.slider);

      this.setHeight();
    }

    setHeight() {
      let splideHeight;
      let slideContain;

      if ( this.Splide.state.is( theme.Splide.STATES.IDLE ) ) {
        if (this.options.autoResize) {
          slideContain = this.slider.querySelectorAll('.splide__slide.is-visible .slide__contain');
        } else {
          slideContain = this.slider.querySelectorAll('.splide__slide .slide__contain');
        }

        slideContain.forEach((slide) => {
          let height = slide.offsetHeight;
          if (splideHeight === undefined || height > splideHeight) {
            splideHeight = height;
          }
        });

        this.sliderList.style.height = `${splideHeight}px`;
      }
    }
  }
  customElements.define(
    'blog-slider-component',
    BlogSliderComponent
  );
}
/******/ })()
;